import React, { useEffect } from 'react';

const OldRileyWiki: React.FC = () => {
  useEffect(() => {
    // Set page title
    document.title = 'Old Riley - Wingipedia';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Old Riley was a one-eyed white horse that accompanied Daisy and George Wood Wingate on their 1885 expedition through Yellowstone Park.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Full-width header section */}
      <div className="w-full bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4 lg:ml-36">
        {/* Mobile header and intro - appears first on mobile */}
        <div className="lg:hidden mb-6">
          {/* Wikipedia-style header */}
          <div className="border-b border-gray-200 pb-2 mb-4">
              <h1 className="text-3xl sm:text-4xl font-semibold mb-2 border-b border-gray-300 pb-1" style={{ fontFamily: 'Hoefler Text, Garamond, Times New Roman, serif', letterSpacing: '-0.02em' }}>
                Old Riley
            </h1>
              <p className="text-sm text-gray-600 italic mb-2">From Wingipedia, the WINGO World encyclopedia</p>
          </div>

          {/* Lead section */}
          <div className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
            <p className="text-base mb-3">
              <strong>Old Riley</strong> was a one-eyed white horse that accompanied <a href="/wingipedia/daisy" className="text-blue-600 hover:underline">Daisy</a> and <a href="/wingipedia/george-wingate" className="text-blue-600 hover:underline">George Wood Wingate</a> on their <a href="/Through_the_Yellowstone_Park_on_Horseback.pdf" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">1885 expedition through Yellowstone Park</a>. Known for his gentle gait and amiable disposition, Old Riley was ridden by Wingate's wife during the journey but suffered from a series of unfortunate accidents that ultimately led to his replacement.
            </p>
          </div>
        </div>

        {/* Desktop header and intro */}
        <div className="hidden lg:block mb-6">
          {/* Wikipedia-style header */}
          <div className="border-b border-gray-200 pb-2 mb-4">
            <h1 className="text-3xl sm:text-4xl font-semibold mb-2 border-b border-gray-300 pb-1" style={{ fontFamily: 'Hoefler Text, Garamond, Times New Roman, serif', letterSpacing: '-0.02em' }}>
              Old Riley
            </h1>
            <p className="text-sm text-gray-600 italic mb-2">From Wingipedia, the free encyclopedia</p>
          </div>

          {/* Desktop bio image - positioned to float right */}
          <div className="hidden lg:block float-right ml-6 mb-6 w-80" style={{ fontFamily: 'Georgia, serif' }}>
            <div className="bg-white border border-gray-300 p-3 text-xs" style={{ fontSize: '11px', lineHeight: '1.3' }}>
              <div className="text-center mb-2">
                <span className="font-bold" style={{ fontSize: '14px' }}>Old Riley</span>
              </div>
              
              <div className="text-center mb-2">
                <img 
                  src="/freedom_horses.png" 
                  alt="Old Riley" 
                  className="w-full h-56 object-cover rounded"
                  style={{ objectPosition: 'center top' }}
                />
              </div>
              
              <div className="space-y-0.5">
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Species:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>Horse</span>
                </div>
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Color:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>White</span>
                </div>
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Eyes:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>One-eyed</span>
                </div>
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Owner:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>George Wood Wingate</span>
                </div>
                <div>
                  <span className="font-bold" style={{ fontSize: '10px' }}>Status:</span>
                  <span className="ml-1" style={{ fontSize: '10px' }}>Replaced</span>
                </div>
              </div>
            </div>
          </div>

          {/* Lead section */}
          <div className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
            <p className="text-base mb-3">
              <strong>Old Riley</strong> was a one-eyed white horse that accompanied <a href="/wingipedia/daisy" className="text-blue-600 hover:underline">Daisy</a> and <a href="/wingipedia/george-wingate" className="text-blue-600 hover:underline">George Wood Wingate</a> on their <a href="/Through_the_Yellowstone_Park_on_Horseback.pdf" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">1885 expedition through Yellowstone Park</a>. Known for his gentle gait and amiable disposition, Old Riley was ridden by Wingate's wife during the journey but suffered from a series of unfortunate accidents that ultimately led to his replacement.
            </p>
          </div>

        </div>
        </div>
      </div>

      {/* Frozen Contents - Desktop only */}
      <div className="hidden lg:block fixed top-36 left-4 w-44 z-10">
        <div className="bg-white p-3" style={{ fontFamily: 'Georgia, serif' }}>
              <div className="flex justify-between items-center mb-2">
                <h2 className="text-sm font-bold">Contents</h2>
                <button className="text-xs text-blue-600 hover:underline">[hide]</button>
              </div>
              <ol className="list-decimal list-inside space-y-0.5 text-xs">
                <li><a href="#yellowstone-expedition" className="text-blue-600 hover:underline">Yellowstone Expedition</a></li>
                <li><a href="#accidents" className="text-blue-600 hover:underline">Accidents and replacement</a></li>
                <li><a href="#legacy" className="text-blue-600 hover:underline">Legacy</a></li>
                <li><a href="#see-also" className="text-blue-600 hover:underline">See also</a></li>
              </ol>
            </div>
          </div>

      {/* Main content area with proper positioning */}
      <div className="w-full py-1">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 lg:ml-36">
          {/* Main content - sections that wrap around bio image */}
          <div className="lg:mr-0">

            {/* Mobile bio image - appears after table of contents */}
            <div className="block lg:hidden mb-6">
              <div className="bg-white border border-gray-300 p-3 text-xs" style={{ fontSize: '11px', lineHeight: '1.3' }}>
                <div className="text-center mb-2">
                  <span className="font-bold" style={{ fontSize: '14px' }}>Old Riley</span>
                </div>
                
                <div className="text-center mb-2">
                  <img 
                    src="/freedom_horses.png" 
                    alt="Old Riley" 
                    className="w-full h-56 object-cover rounded"
                    style={{ objectPosition: 'center top' }}
                  />
                </div>
                
                <div className="space-y-0.5">
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Species:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>Horse</span>
                  </div>
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Color:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>White</span>
                  </div>
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Eyes:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>One-eyed</span>
                  </div>
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Owner:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>George Wood Wingate</span>
                  </div>
                  <div>
                    <span className="font-bold" style={{ fontSize: '10px' }}>Status:</span>
                    <span className="ml-1" style={{ fontSize: '10px' }}>Replaced</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Yellowstone Expedition section */}
            <section id="yellowstone-expedition" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>
                <span className="block w-full lg:inline lg:max-w-[calc(100%-350px)]">Yellowstone Expedition</span>
              </h2>
              
              <div className="float-right ml-4 mb-3 w-48 lg:block hidden bg-gray-50 p-2 rounded">
                <img 
                  src="/old_riley.png" 
                  alt="Old Riley during the Yellowstone expedition" 
                  className="w-full h-auto hover:opacity-90 transition-opacity cursor-pointer border border-gray-300 rounded"
                />
                <p className="text-xs text-gray-600 italic mt-1" style={{ fontSize: '10px', lineHeight: '1.2' }}>
                  Old Riley during the Yellowstone expedition
                </p>
              </div>

              {/* Mobile version - smaller, still floating */}
              <div className="float-right ml-3 mb-3 w-44 block lg:hidden bg-gray-50 p-2 rounded">
                <img 
                  src="/old_riley.png" 
                  alt="Old Riley during the Yellowstone expedition" 
                  className="w-full h-auto hover:opacity-90 transition-opacity cursor-pointer border border-gray-300 rounded"
                />
                <p className="text-xs text-gray-600 italic mt-1 pl-1" style={{ fontSize: '8px', lineHeight: '1.1' }}>
                  Old Riley during the Yellowstone expedition
                </p>
              </div>

              <p className="mb-3 text-base">
                Old Riley was selected as one of the horses for George Wood Wingate's 1885 expedition through <a href="/Through_the_Yellowstone_Park_on_Horseback.pdf" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Yellowstone Park</a>. He was known for his gentle gait and amiable disposition, making him a suitable choice for carrying Wingate's wife during the journey. Old Riley was accompanied by other horses including <a href="/wingipedia/daisy" className="text-blue-600 hover:underline">Daisy</a>, who would later become the foundation of the WINGO World system.
              </p>
            </section>

            {/* Accidents and replacement */}
            <section id="accidents" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>Accidents and replacement</h2>
              
              <p className="mb-3 text-base">
                Despite his gentle nature, Old Riley suffered from a series of unfortunate accidents during the expedition. These incidents, combined with the challenging terrain and conditions of the Yellowstone journey, ultimately led to his replacement by another horse. The specific details of these accidents were documented in Wingate's account of the expedition.
              </p>
            </section>

            {/* Legacy */}
            <section id="legacy" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>Legacy</h2>
              
              <p className="mb-3 text-base">
                While Old Riley's time on the expedition was cut short, he remains part of the historical record of the Wingate family's journey through Yellowstone. His gentle disposition and the unfortunate circumstances of his replacement serve as a reminder of the challenges faced by both humans and animals during 19th-century wilderness expeditions.
              </p>
            </section>

            {/* See also */}
            <section id="see-also" className="mb-6" style={{ fontFamily: 'Georgia, serif', lineHeight: '1.4' }}>
              <h2 className="text-2xl font-medium mb-3 border-b border-gray-300 pb-1" style={{ fontFamily: 'Georgia, serif' }}>See also</h2>
              <ul className="list-disc list-inside space-y-1 text-base">
                <li><a href="/wingipedia/daisy" className="text-blue-600 hover:underline">Daisy</a></li>
                <li><a href="/wingipedia/george-wingate" className="text-blue-600 hover:underline">George Wood Wingate</a></li>
                <li><a href="/wingipedia/wingate" className="text-blue-600 hover:underline">Historic Wingate Track</a></li>
                <li><a href="/wingipedia/wingo" className="text-blue-600 hover:underline">WINGO</a></li>
              </ul>
            </section>
              </div>
        </div>
      </div>
    </div>
  );
};

export default OldRileyWiki;
